import { useCallback, useEffect, useState } from 'react';
import localforage from 'localforage';
// @ts-ignore
import hash from 'object-hash';
import { useRecoilState } from 'recoil';
import { shipsState } from 'atoms/ships';
import { Ship } from 'types/ship';

function useLocalShips() {
  const [ships, setShips] = useState<Ship[] | null>(null);

  async function retrieveLocalShips() {
    const shipListCached = await localforage
      .getItem<any[]>('shipListzz')
      .then(async (value) => value || []);
    setShips(shipListCached);
  }

  useEffect(() => {
    retrieveLocalShips();
  }, []);

  return ships;
}

export function useShips() {
  const [ships, setShips] = useRecoilState(shipsState);
  const localShips = useLocalShips();

  const retrieveShips = useCallback(async () => {
    if (localShips === null) return;

    const shipList = await fetch(
      'https://annimon.com/pages/azurlane/shipsExt.json',
      { cache: 'no-store' },
    )
      .then((res) => res.json())
      .then((data) => data.sort((a: any, b: any) => a.id - b.id));

    if (hash(localShips) !== hash(shipList)) {
      await localforage.setItem('shipList', shipList);
      setShips(shipList);
    }
  }, [localShips, setShips]);

  useEffect(() => {
    if (!ships) {
      retrieveShips();
    }
  }, [ships, retrieveShips]);

  return ships;
}
